"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFilterExpressByOpenFilter = exports.parseOpenFilterByExpress = exports.parseInnerFilter = exports.parseOpenFilter = exports.validateOpenFilter = void 0;
const view_types_1 = require("../types/view_types");
const utils_1 = require("../model/utils");
const field_1 = require("../model/field");
const utils_2 = require("../utils");
const joi_1 = __importDefault(require("joi"));
const validate_schema_1 = require("../model/field/validate_schema");
const types_1 = require("../types");
const interface_1 = require("../automation_manager/interface");
const lodash_1 = require("lodash");
const getConjunctionsByGroup = (conditionGroup) => {
    const conjunctions = Object.keys(conditionGroup);
    if (conjunctions.length > 1) {
        throw new Error('Only the or or or and operator is supported');
    }
    if (conjunctions.length === 0) {
        return null;
    }
    return conjunctions;
};
const parseConditionsOrGroupBase = (conditions, parseConditionGroup, parseCondition) => {
    return conditions.map((item) => {
        if (Object.keys(item).some(v => (0, validate_schema_1.enumToArray)(view_types_1.FilterConjunction).includes(v))) {
            return parseConditionGroup(item);
        }
        return parseCondition(item);
    }).filter((v) => !(0, lodash_1.isEmpty)(v));
};
/**
 * Verify that the openFilter schema conforms to the convention.
 * Only the whole schema is checked for parsing, the value of the corresponding filter is not checked, it is parsed to the value.
 * @param filterInfo
 * @param canGroup Switch to support filter groups.
 */
function validateOpenFilter(filterInfo, canGroup = false) {
    const validateConditionSchema = (condition) => {
        return joi_1.default.custom((value, helper) => {
            if (Object.prototype.toString.call(value) !== '[object Object]') {
                return helper.error('Object invalid');
            }
            const { fieldKey } = value, valueObj = __rest(value, ["fieldKey"]);
            if (!fieldKey || typeof fieldKey !== 'string') {
                return helper.error('fieldKey does not exist');
            }
            // Detects if it is an object with a fieldType of key.
            const fieldTypeArray = (0, validate_schema_1.enumToArray)(types_1.APIMetaFieldType);
            const fieldType = Object.keys(valueObj).find(i => fieldTypeArray.includes(i));
            if (!fieldType) {
                return helper.error('No fieldType exists');
            }
            // Check if it is an object with FOperator as key.
            const opObj = valueObj[fieldType];
            const opArray = (0, validate_schema_1.enumToArray)(view_types_1.FOperator);
            const op = Object.keys(opObj).find(i => opArray.includes(i));
            if (!op) {
                return helper.error('No operator exists');
            }
            return value;
        }).validate(condition);
    };
    const validateConditionGroupSchema = (conditionGroup) => {
        return joi_1.default.custom((value, helper) => {
            if (Object.prototype.toString.call(value) !== '[object Object]') {
                return helper.error('Object invalid');
            }
            const keys = Object.keys(value);
            if (keys.length > 1) {
                return helper.error('Only the or or and operator is supported');
            }
            const fcArray = (0, validate_schema_1.enumToArray)(view_types_1.FilterConjunction);
            const filterConjunction = Object.keys(value).find(i => fcArray.includes(i));
            if (!filterConjunction) {
                return value;
            }
            const conditionGroupValue = value[filterConjunction];
            if (!conditionGroupValue) {
                return value;
            }
            if (!Array.isArray(conditionGroupValue)) {
                return helper.error('Array invalid');
            }
            let errorMessage;
            const validateConditionGroupValueSuccess = conditionGroupValue.every(item => {
                const isGroup = Object.prototype.toString.call(value) === '[object Object]' && Object.keys(item).every(k => fcArray.includes(k));
                // Temporarily block out group.
                if (isGroup && !canGroup) {
                    errorMessage = 'Not support group condition';
                    return false;
                }
                const { error } = isGroup ? validateConditionGroupSchema(item) : validateConditionSchema(item);
                errorMessage = error === null || error === void 0 ? void 0 : error.message;
                return !error;
            });
            if (!validateConditionGroupValueSuccess && errorMessage) {
                return helper.error(errorMessage);
            }
            return value;
        }).validate(conditionGroup);
    };
    return validateConditionGroupSchema(filterInfo);
}
exports.validateOpenFilter = validateOpenFilter;
/**
 * Generate external filter structures.
 * @param meta
 * @param viewId
 * @param state
 */
function parseOpenFilter(meta, viewId, state) {
    const view = meta.views.find(v => v.id === viewId);
    if (!view || !view.filterInfo) {
        return {};
    }
    const { fieldMap } = meta;
    const parseCondition = (condition) => {
        const { fieldId, fieldType, operator, value } = condition;
        const _field = fieldMap[fieldId];
        if (!_field) {
            return {};
        }
        const field = field_1.Field.bindContext(_field, state);
        // Filter out
        if (operator === view_types_1.FOperator.IsRepeat) {
            return {};
        }
        // Check operator, filter for non-existent operators.
        if (!field.acceptFilterOperators.includes(operator)) {
            return {};
        }
        return {
            fieldKey: fieldId,
            [(0, utils_1.getFieldTypeString)(fieldType)]: {
                [operator]: field.filterValueToOpenFilterValue(value)
            }
        };
    };
    const parseConditionGroup = (conditionGroup) => {
        const { conditions, conjunction } = conditionGroup;
        return {
            [conjunction]: conditions.map(item => {
                // TODO If it's a filter group, you only need to determine whether
                // the item is a filter condition or a filter group, and if it's a filter group, 
                // recursively parseConditionGroup.
                return parseCondition(item);
            }).filter(v => Object.keys(v).length > 0)
        };
    };
    return parseConditionGroup(view.filterInfo);
}
exports.parseOpenFilter = parseOpenFilter;
/**
 * Convert to internal filter structure.
 * @param filterInfo
 * @param context
 */
function parseInnerFilter(filterInfo, context) {
    const { fieldMap, state } = context;
    const exitIds = [];
    const parseCondition = (condition) => {
        const { fieldKey } = condition, valueMap = __rest(condition, ["fieldKey"]);
        const field = fieldMap[fieldKey];
        if (!field) {
            return;
        }
        const fieldBind = field_1.Field.bindContext(field, state);
        const conditionId = (0, utils_2.getNewId)(utils_2.IDPrefix.Condition, exitIds);
        const valueMapKey = (0, utils_1.getFieldTypeString)(field.type);
        const filterValueMap = valueMap[valueMapKey];
        if (filterValueMap == null) {
            return;
        }
        const operator = Object.keys(filterValueMap)[0];
        exitIds.push(conditionId);
        return {
            conditionId,
            fieldId: fieldKey,
            fieldType: field.type,
            operator,
            value: fieldBind.openFilterValueToFilterValue(filterValueMap[operator])
        };
    };
    const parseConditionGroup = (conditionGroup) => {
        const conjunctions = getConjunctionsByGroup(conditionGroup);
        return conjunctions ? {
            conjunction: conjunctions[0],
            conditions: parseConditionsOrGroupBase(conditionGroup[conjunctions[0]], parseConditionGroup, parseCondition)
        } : null;
    };
    return parseConditionGroup(filterInfo);
}
exports.parseInnerFilter = parseInnerFilter;
/**
 * Converting expressions to external structures.
 * Expressions for filter components.
 * @param filterExpress
 * @param context
 */
function parseOpenFilterByExpress(filterExpress, context) {
    const { meta, state } = context;
    const { fieldMap } = meta;
    const parseCondition = (condition) => {
        var _a, _b;
        const { operator, operands } = condition;
        const fieldId = (_a = operands[0]) === null || _a === void 0 ? void 0 : _a.value;
        const value = (_b = operands[1]) === null || _b === void 0 ? void 0 : _b.value;
        const field = fieldMap[fieldId];
        if (!field) {
            return;
        }
        const fieldModel = field_1.Field.bindContext(field, state);
        // Check operator, filter for non-existent operators.
        if (!fieldModel.acceptFilterOperators.includes(operator)) {
            return {};
        }
        return {
            fieldKey: fieldId,
            [(0, utils_1.getFieldTypeString)(field.type)]: {
                [operator]: fieldModel.filterValueToOpenFilterValue(value)
            }
        };
    };
    const parseConditionGroup = (conditionGroup) => {
        if (!conditionGroup) {
            return {};
        }
        const { operator, operands } = conditionGroup;
        return {
            [operator]: operands.map((item) => {
                if ((0, validate_schema_1.enumToArray)(view_types_1.FilterConjunction).includes(item.value.operator)) {
                    return parseConditionGroup(item.value);
                }
                return parseCondition(item.value);
            }).filter((v) => Object.keys(v).length > 0)
        };
    };
    return parseConditionGroup(filterExpress.value);
}
exports.parseOpenFilterByExpress = parseOpenFilterByExpress;
/**
 * Converting external structures to expression structures.
 * @param filterInfo
 * @param context
 */
function parseFilterExpressByOpenFilter(filterInfo, context) {
    const { fieldMap, state } = context;
    const parseCondition = (condition) => {
        const { fieldKey } = condition, valueMap = __rest(condition, ["fieldKey"]);
        const field = fieldMap[fieldKey];
        if (!field) {
            return;
        }
        const fieldBind = field_1.Field.bindContext(field, state);
        const fieldType = Object.keys(valueMap)[0];
        if (!fieldType || (0, utils_1.getFieldTypeString)(field.type) !== fieldType) {
            return;
        }
        const value = valueMap[fieldType];
        return {
            type: interface_1.OperandTypeEnums.Expression,
            value: {
                operator: Object.keys(value)[0],
                operands: [
                    {
                        type: interface_1.OperandTypeEnums.Literal,
                        value: field.id
                    },
                    {
                        type: interface_1.OperandTypeEnums.Literal,
                        value: fieldBind.openFilterValueToFilterValue(value[Object.keys(value)])
                    }
                ]
            }
        };
    };
    const parseConditionGroup = (conditionGroup) => {
        const conjunctions = getConjunctionsByGroup(conditionGroup);
        return conjunctions ? {
            type: interface_1.OperandTypeEnums.Expression,
            value: {
                operator: conjunctions[0],
                operands: parseConditionsOrGroupBase(conditionGroup[conjunctions[0]], parseConditionGroup, parseCondition)
            }
        } : null;
    };
    return parseConditionGroup(filterInfo);
}
exports.parseFilterExpressByOpenFilter = parseFilterExpressByOpenFilter;
//# sourceMappingURL=filter_data_structure_parse.js.map